import { Chip } from "$components/chip";
import { useIntl } from "react-intl";

const statusMap = {
  DRAFT: {
    color: "primary",
    label: { id: "invoicing.invoice.summary.draft", defaultMessage: "Draft" },
  },
  PENDING: {
    color: "warning",
    label: {
      id: "invoicing.invoice.summary.pending",
      defaultMessage: "Pending payment",
    },
  },
  UNPAID: {
    color: "warning",
    label: { id: "invoicing.invoice.summary.unpaid", defaultMessage: "Unpaid" },
  },
  PAID: {
    color: "success",
    label: { id: "invoicing.invoice.summary.paid", defaultMessage: "Paid" },
  },
  PARTIALLY_PAID: {
    color: "warning",
    label: {
      id: "invoicing.invoice.summary.partiallyPaid",
      defaultMessage: "Partially Paid",
    },
  },
  VOID: {
    color: "grey",
    label: { id: "invoicing.invoice.summary.void", defaultMessage: "Void" },
  },
  REFUNDED: {
    color: "grey",
    label: {
      id: "invoicing.invoice.summary.refunded",
      defaultMessage: "Refunded",
    },
  },
  PARTIALLY_REFUNDED: {
    color: "grey",
    label: {
      id: "invoicing.invoice.summary.partiallyRefunded",
      defaultMessage: "Partially Refunded",
    },
  },
};

export const InvoiceStatusChip = ({ status }: { status: string }) => {
  const { formatMessage } = useIntl();
  if (!status) return null;
  return (
    <Chip
      label={formatMessage(statusMap[status].label)}
      color={statusMap[status].color}
    />
  );
};
